import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ClutchIcon } from "../../../../app-constants";
import { Link } from "gatsby";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const slides = [
  {
    title: "Stephanie Berman",
    desig: "CEO & Founder, Engagement Through Education",
    txt: "Everything has been flowing pretty smoothly.",
    rating: "4.5",
    feedback: {
      quality: "5.0",
      schedule: "4.0",
      Cost: "5.0",
      Willing: "5.0",
    },
  },
  {
    title: "Brian Ferguson",
    desig: "Executive Director, Project Impact Mississippi",
    txt: "It’s been an awesome experience. It feels like we’re a family.",
    rating: "5.0",
    feedback: {
      quality: "5.0",
      schedule: "5.0",
      Cost: "5.0",
      Willing: "5.0",
    },
  },
  {
    title: "Cameron Maxey",
    desig: "Co-Founder, Younit",
    txt: "Their communication has been great.",
    rating: "5.0",
    feedback: {
      quality: "5.0",
      schedule: "5.0",
      Cost: "5.0",
      Willing: "5.0",
    },
  },
  // Add more objects as needed
];

const duplicatedSlides = [...slides, ...slides, ...slides];

const Associatesslider = () => {
  return (
    <div className="associatesslider hv-100 p-100">
      <Container fluid className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} className="my-auto">
            <Row>
              <Col
                xs={12}
                md={6}
                lg={8}
                xl={8}
                xxl={8}
                className="text-center m-auto"
              >
                <h2>Our Clients Love Our Work!</h2>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                <Swiper
                  loop={true}
                  // navigation={true}
                  spaceBetween={20}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  modules={[Autoplay]}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 2.7,
                    },
                    1400: {
                      slidesPerView: 3,
                    },
                    1600: {
                      slidesPerView: 3.2,
                    },
                  }}
                  className="carousel_lp"
                >
                  {duplicatedSlides.map((slide, index) => (
                    <SwiperSlide key={index}>
                      <div className="associates_card">
                        <div className="associates_content">
                          <div className="name">
                            {slide.title}
                            <span> {slide.desig}</span>
                          </div>
                          <p>{slide.txt}</p>
                          <div className="slider-btn">
                            <Link
                              to="https://clutch.co/profile/tekrevol?page=2#review-1831525"
                              className="border_btn"
                              aria-label="TekRevol Contact"
                              rel="noopener nofollow"
                            >
                              Check Review
                            </Link>
                          </div>
                        </div>
                        <div className="associates_rating">
                          <div className="rating_number">{slide.rating}</div>

                          <ul>
                            <li>
                              Quality <span>{slide.feedback.quality}</span>
                            </li>

                            <li>
                              Schedule <span>{slide.feedback.schedule}</span>
                            </li>
                            <li>
                              Cost <span>{slide.feedback.Cost}</span>
                            </li>
                            <li>
                              Willing to Refer{" "}
                              <span>{slide.feedback.Willing}</span>
                            </li>
                          </ul>
                          <p>Powered by {ClutchIcon}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Associatesslider;
